import Vue from "vue";
import Vuex from "vuex";
import * as autenticacao from "./modules/autenticacao";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    autenticacao
  },
  strict: process.env.NODE_ENV !== "production"
});
